export default __webpack_public_path__ + "static/media/audiophile-logo.d4fa59f4.svg";